import { SpecialVisualisationParams, SpecialVisualizationSvelte } from "../SpecialVisualization"
import SvelteUIElement from "../Base/SvelteUIElement"
import MarkAsFavourite from "../Popup/MarkAsFavourite.svelte"
import MarkAsFavouriteMini from "../Popup/MarkAsFavouriteMini.svelte"

class FavouriteStatus extends SpecialVisualizationSvelte {
    funcName = "favourite_status"

    docs =
        "A button that allows a (logged in) contributor to mark a location as a favourite location"
    args = []
    group = "favourites"

    constr(params: SpecialVisualisationParams): SvelteUIElement {
        return new SvelteUIElement(MarkAsFavourite, params)
    }
}

class FavouriteIcon extends SpecialVisualizationSvelte {
    funcName = "favourite_icon"
    group = "favourites"
    docs =
        "A small button that allows a (logged in) contributor to mark a location as a favourite location, sized to fit a title-icon"
    args = []

    constr(params: SpecialVisualisationParams): SvelteUIElement {
        return new SvelteUIElement(MarkAsFavouriteMini, params)
    }
}

export class FavouriteVisualisations {
    public static initList(): SpecialVisualizationSvelte[] {
        return [new FavouriteStatus(), new FavouriteIcon()]
    }
}
